import { toast } from "sonner"


export const ErrorTost= async(message)=>{
    return toast(message, {
        closeButton: true,
        style: {
          backgroundColor: "#ffe0e1",
          color: "#e60000"
        },
      })
}


export const SuccessTost= async(message)=>{
    return toast(message, {
        closeButton: true,
        style: {
          backgroundColor: "#ecfdf3",
          color: "#008a2e"
        },
      })
}